import { render, staticRenderFns } from "./ContentFeaturesSection.vue?vue&type=template&id=1c7a89c7&scoped=true&"
import script from "./ContentFeaturesSection.vue?vue&type=script&lang=js&"
export * from "./ContentFeaturesSection.vue?vue&type=script&lang=js&"
import style0 from "./ContentFeaturesSection.vue?vue&type=style&index=0&id=1c7a89c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a89c7",
  null
  
)

export default component.exports